import { isObject } from './validators.js';
import { flatMap as theRealFlatMap } from './array.js';


/**
 * Extracts a prop from an object
 * @param {Array} props An array of string prop path to extract from an object
 * @param {Object} obj An object from which to extract props
 * @returns {any|undefined} Whatever is found on the object, or undefined
 */
export function prop(props = [], obj) {
    return propOr(undefined, props, obj);
}

/**
 * Extracts a prop from an object or returns the default value if the result is falsy
 *
 * @param {Any} defaultVal Anything
 * @param {Array} props An array of string prop path to extract from an object
 * @param {Object} obj An object from which to extract props
 * @returns {any} Whatever is found on the object, or defaultVal
 */
export function propOr(defaultVal, props = [], obj) {
    if (props.length === 0) {
        return obj;
    }
    if (!isObject(obj) || !obj.hasOwnProperty(props[0])) {
        return defaultVal;
    }
    const val = obj[props[0]];
    return propOr(defaultVal, props.slice(1), val);
}

/**
 * Apply a function to an array of objects, and flatten result arrays into one
 * array
 *
 * @param {Array} arr An array to apply a function to
 * @param {Function} fn A function to apply to the array contents
 * @return {Array} The processed array
 * @deprecated Please use util/array#flatMap or util/array#flatten
 */
export const flatMap = (arr, fn = (x) => x) => theRealFlatMap(fn, arr);

/**
 * Given a path, recursively construct an object with the given nested path
 *
 * @param {Array} keys - keys to be nested
 * @param {*} value - final value to be set as the value of the last key
 * @param {Object} state - starting state
 *
 * @returns {Object} Object with the given nested path
 */
export const buildNestedObject = (keys, value = {}, state = {}) => {
    if (keys.length <= 0 || !isObject(state)) {
        return state;
    }
    const key = keys.shift();

    state = { ...state };
    if (keys.length <= 0) {
        state[key] = value;
    }
    state[key] = buildNestedObject(keys, value, state[key]);
    return state;
};
